import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { repairItems } from "@/mocks/home";

export default function RepairItems() {
  const [openId, setOpenId] = useState<string | null>(repairItems[0]?.id ?? null);

  return (
    <section id="items" className="w-full bg-background-100 py-20 md:py-28">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-[0.85fr_1.3fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <SectionHeading
            align="left"
            eyebrow="Repair Items"
            title="이런 증상,"
            highlight="맡겨주세요"
            desc="증상만으로도 원인을 예측할 수 있습니다. 항목을 눌러 자세한 안내와 예상 수리 시간을 확인해 보세요."
          />

          <div className="reveal mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=Technician%20hands%20with%20anti-static%20gloves%20inspecting%20a%20laptop%20motherboard%20with%20a%20magnifier%20and%20precision%20tools%2C%20cool%20blue%20task%20lighting%2C%20clean%20organized%20workbench%2C%20dark%20muted%20background%2C%20high%20detail%20repair%20laboratory%20photography&width=900&height=600&seq=diagnosis-board-mfx&orientation=landscape"
              alt="맥북 메인보드를 확대경으로 정밀 진단하는 모습"
              title="맥픽스 정밀 진단 장비"
              className="h-[240px] w-full object-cover object-top"
            />
            <div className="flex items-center gap-3 bg-background-50 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-customer-service-2-line text-xl"></i>
              </span>
              <p className="font-body text-sm leading-relaxed text-foreground-700">
                증상을 정확히 모르셔도 괜찮습니다. 상담 후 안내해 드립니다.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {repairItems.map((item, index) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className={`reveal overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
                style={{ transitionDelay: `${index * 40}ms` }}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : item.id)}
                  aria-expanded={open}
                  className="flex w-full items-center gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100/70 md:px-6"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 font-label text-sm font-black text-secondary-700">
                    {item.category}
                  </span>
                  <span className="flex-1 font-heading text-base font-black text-foreground-950 md:text-lg">
                    {item.title}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                      open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="border-t border-background-200 px-5 pb-6 pt-5 md:px-6">
                      <p className="font-body text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                        {item.desc}
                      </p>
                      <div className="mt-5 flex flex-wrap gap-2">
                        {item.symptoms.map((s) => (
                          <span
                            key={s}
                            className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 font-label text-xs font-bold text-secondary-800"
                          >
                            <i className="ri-error-warning-line"></i>
                            {s}
                          </span>
                        ))}
                      </div>
                      <div className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-50 px-3.5 py-2 font-label text-sm font-bold text-primary-700">
                        <i className="ri-time-line"></i>
                        예상 소요 시간 : {item.time}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}